<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <path class="fil0" d="M1117.52 2841.19l2074.44 -2588.15c56.47,-70.44 160.36,-81.91 230.83,-25.44l78.94 63.28c70.47,56.48 81.9,160.38 25.43,230.82l-2259.72 2819.3c-32.38,40.4 -80.35,61.39 -128.69,61.31 -59.5,13.83 -124.63,-6.06 -165.48,-56.53l-897.96 -1109.51c-94.99,-117.38 -5.92,-324.58 110.53,-381.08 81.36,-39.48 166.48,40.53 223.39,110.83l708.29 875.17z"/>
 </g>
</svg>
